import cx from "@hsl/core/utils/cx";
import { type FundDataWithType } from "@hsl/fund-explorer/metaSchemas";

import useFundPageURL from "../../../hooks/useFundPageURL";
import useExplorerStore from "../../../store/store";
import SubscriptionButtons from "../../Subscription/SubscriptionButtons";
import { AboutView, TagsView } from "../views";
import { FundCardTitle } from "./FundCardTitle";

interface Props {
    fund: FundDataWithType;
    mode: "card" | "list";
    showTitle?: boolean;
    onShowModal?: () => void;
    className?: string;
    onSubscribeButtonClick?: (
        mode: "watch" | "subscribe",
    ) => (loggedIn: boolean) => void;
    isWatching?: boolean;
    isSubscribed?: boolean;
    hasUpdates?: boolean;
}

export const FundCardResponsiveContent = ({
    fund,
    mode,
    onShowModal,
    showTitle = true,
    className,
    onSubscribeButtonClick,
    isWatching,
    isSubscribed,
    hasUpdates,
}: Props) => {
    const isPMC =
        useExplorerStore((store) => store.config.productType) === "pmc";
    const { name, fundPageURL } = fund.data.data;
    const url = useFundPageURL(fundPageURL);

    const showSubButtons =
        typeof onSubscribeButtonClick !== "undefined" &&
        typeof isWatching !== "undefined" &&
        typeof isSubscribed !== "undefined" &&
        typeof hasUpdates !== "undefined";

    return (
        <div
            className={cx("block w-full appearance-none text-left", className)}
            onClick={onShowModal}
        >
            {showTitle && (
                <>
                    {mode === "list" ? (
                        <a
                            href={url ?? ""}
                            target="_blank"
                            onClick={(e) => e.stopPropagation()}
                            rel="noreferrer"
                        >
                            <FundCardTitle>{name}</FundCardTitle>
                        </a>
                    ) : (
                        <FundCardTitle>{name}</FundCardTitle>
                    )}
                </>
            )}
            {mode === "card" && (
                <>
                    <AboutView fund={fund} />
                    {(!isPMC || showSubButtons) && (
                        <div className="mt-2 flex w-full items-center justify-between">
                            {isPMC ? <div /> : <TagsView fund={fund} />}
                            {showSubButtons && (
                                <SubscriptionButtons
                                    fund={fund}
                                    isWatching={isWatching}
                                    isSubscribed={isSubscribed}
                                    hasUpdates={hasUpdates}
                                    onClickWatch={onSubscribeButtonClick(
                                        "watch",
                                    )}
                                    onClickSubscribe={onSubscribeButtonClick(
                                        "subscribe",
                                    )}
                                />
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
